/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Divider,
  Dropdown,
  InputNumber,
  type MenuProps,
  message,
  Row,
  Space,
  Tooltip,
} from "antd";
import { LogsViewWithTitle } from "../components/LogsView";
import {
  type RequestLogsType,
  type InstanceLogsType,
} from "../redux/slices/midservice/midserviceTypes";
import { useAppDispatch, useAppSelector } from "../hooks/hooks";
import { API } from "../api/Api";
import { selectCanUserEdit } from "../redux/slices/user/userSlice";
import { items, timePicker } from "../utils/logs";
import { timestampToReadableZone } from "../utils/time";
import { QuestionCircleOutlined, DownOutlined } from "@ant-design/icons";
import Title from "antd/lib/typography/Title";
import {
  deleteLogsAsync,
  requestLogsAsync,
} from "../redux/slices/midservice/midserviceSlice";

interface LogsTabProps {
  fullDeviceId: string;
  midserviceType: string;
  logs: InstanceLogsType[];
  apiLogs: InstanceLogsType[];
  domain?: string;
}

export const LogsTab = ({
  fullDeviceId,
  midserviceType,
  logs,
  apiLogs,
  domain,
}: LogsTabProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const [logDays, setLogDays] = useState<number>(-1);
  const [logsTTL, setLogsTTL] = useState(-1);
  const canUserEdit = useAppSelector(selectCanUserEdit);
  const isMidservice = midserviceType === "MIDSERVICE";

  const deviceId = isMidservice ? fullDeviceId.split("-")[0] : fullDeviceId;

  useEffect(() => {
    if (deviceId == null) return;
    API.checkLogs(deviceId).then(({ data }) => {
      setLogsTTL(data.ttl);
    });
  }, []);

  const onChange = (value: any): void => {
    setLogDays(value);
    console.log("changed", value);
  };

  const onLogRequestButton = (value: any): void => {
    if (deviceId == null || typeof domain === "undefined") return;
    console.log("clicked", value);
    const requestLogsParams: RequestLogsType = {
      domain,
      deviceId: fullDeviceId,
      days: logDays,
    };
    dispatch(requestLogsAsync(requestLogsParams));
  };

  const onDeleteLogButton = (): void => {
    if (deviceId == null || typeof domain === "undefined") return;
    console.log("onDeleteLogButton");
    dispatch(
      deleteLogsAsync({
        domain,
        deviceId: fullDeviceId,
      }),
    );
  };

  const handleMenuClick: MenuProps["onClick"] = (e) => {
    if (deviceId == null) return;
    API.switchApiLogs(deviceId, timePicker[e.key]).then(({ data }) => {
      const ttl = timestampToReadableZone(data.ttl * 1000);
      setLogsTTL(data.ttl);
      message.success(`Логи включены до ${ttl}`);
    });
  };

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  const disableApiLogs = (): void => {
    if (deviceId == null) return;
    API.switchApiLogs(deviceId).then(() => {
      setLogsTTL(-1);
      message.success("Логи отключены");
    });
  };

  return (
    <>
      {isMidservice ? (
        <>
          <Title level={5}>Запрос логов</Title>
          <Row wrap={false}>
            <Col flex="auto">
              <Tooltip
                title="Период запроса логов с текушего момента. Если -1, запрос на все логи"
                style={{ margin: "100px" }}
              >
                <QuestionCircleOutlined style={{ margin: 10 }} />
              </Tooltip>
              <InputNumber
                style={{ width: 200 }}
                min={-1}
                placeholder={"Количество дней"}
                onChange={onChange}
              />
            </Col>
            <Col flex="none">
              <Button
                type="primary"
                onClick={onLogRequestButton}
                disabled={!canUserEdit}
              >
                Запросить
              </Button>
            </Col>
          </Row>
          <Divider />
        </>
      ) : undefined}
      <Title level={5}>Управление</Title>

      <Row gutter={[8, 8]}>
        {isMidservice ? (
          <Col>
            <Button
              type="primary"
              danger
              onClick={onDeleteLogButton}
              disabled={!canUserEdit}
            >
              Удалить все логи на устройстве
            </Button>
          </Col>
        ) : undefined}
        <Col>
          {logsTTL > 0 ? (
            <Tooltip
              title={`API-логирование включено до ${timestampToReadableZone(
                logsTTL * 1000,
              )}`}
            >
              <Button
                style={{ backgroundColor: "#fadb14", color: "#000000" }}
                onClick={disableApiLogs}
              >
                <Space>Выключить API-логирование</Space>
              </Button>
            </Tooltip>
          ) : (
            <Dropdown
              menu={menuProps}
              disabled={!canUserEdit}
              trigger={["click"]}
            >
              <Button type="primary">
                <Space>
                  Включить логи запросов в API
                  <DownOutlined />
                </Space>
              </Button>
            </Dropdown>
          )}
        </Col>
      </Row>

      <Divider />
      <LogsViewWithTitle title="Логи устройства" logs={logs} />

      <Divider />
      <LogsViewWithTitle title="Логи API" logs={apiLogs} />

      <div style={{ height: "32px" }} />
    </>
  );
};
